<template>
  <div>
    <input
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    />
    <div
      v-loading="loading"
      class="drop"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
    >
      <slot />
      <template v-if="!$slots.default">拖拽文件到这里</template>
    </div>
    <sheetSelect
      ref="sheetSelect"
      :show="sheetSelectShow"
      :list="list"
      :before-close="beforeClose"
    />
  </div>
</template>

<script>
const XLSX = require('./export/xlsx.js')
import SheetSelect from "./sheetSelect";
import { parseTime } from "@/utils";
export default {
  components: { SheetSelect },
  props: {
    onSuccess: Function, // eslint-disable-line
  },
  data() {
    return {
      loading: false,
      sheetSelectShow: false,
      sheetName: null, // excel 选中的表名（tab名）
      file: {}, // 当前要上传的excel文件
      list: [], // excel 表名
      excelData: {
        header: null,
        results: null,
      },
    };
  },
  methods: {
    // 判断是否excel文件
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    // 拖拽事件
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error("Only support uploading one file!");
        return;
      }
      const rawFile = files[0]; // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$message.error(
          "Only supports upload .xlsx, .xls, .csv suffix files"
        );
        return false;
      }
      this.beforeUpload(rawFile); // 上传
      e.stopPropagation();
      e.preventDefault();
    },
    // 元素正在拖动到放置目标时触发
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    // 浏览按钮 点击事件 (供父组件调用)
    handleUpload() {
      this.$refs["excel-upload-input"].click();
    },
    // input change事件
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      if (!rawFile) return;
      this.beforeUpload(rawFile);
    },
    // 上传要执行的判断
    beforeUpload(file) {
      
      this.file = file; // 当前要上传的excel文件
      // console.log(file,'sfffssfdsdff')
      const isLt5M = file.size / 1024 / 1024 < 5;
      // 2021-07-31 hz说取消限制，所以先注释掉
      // if (isLt5M) {
      this.sheetName = null; // 置空
      const reader = new FileReader();
     reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        
        if (workbook.SheetNames.length == 1) {
          this.upload(file);
        } else if(workbook.SheetNames.length > 1){
          this.list = workbook.SheetNames;
          this.sheetSelectShow = true; // 弹出 excel 表单选择弹窗
        }else{
          this.$message.error("表格对象识别失败！请确保表格可读可写！")
        }
      };
      
      // } else {
      //   this.$message({
      //     message: '请上传的excel文件最大不要过5MB',
      //     type: 'warning'
      //   })
      // }
    },
    // 上传
    async upload(rawFile) {
      this.$refs["excel-upload-input"].value = null; // fix can't select the same excel
      this.loading = true;
      this.$nextTick(() => {
        // console.log(rawFile,'rawFilerawFile')
        this.readerData(rawFile).finally(() => {
          this.loading = false;
        });
      });
    },
    // 读取 数据
    readerData(rawFile) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array", cellDates: true });
          const firstSheetName = workbook.SheetNames[0];
          const sheetName = this.sheetName ? this.sheetName : firstSheetName;
          const worksheet = workbook.Sheets[sheetName];
          console.log('worksheet=', worksheet)
          const header = this.getHeaderRow(worksheet);
          
          const results = this.getContantRow(worksheet);
          console.log('resultsresults=', results)
          this.generateData({ header, results });
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    // 获取内容
    getContantRow(sheet) {
      const contant = XLSX.utils.sheet_to_json(sheet);
      // 2023-06-20不再对各字段特殊处理，如需处理，修改源码！搜索“表格导入维护”和sheet_to_json方法
      console.log(sheet,contant,'contant')
      return contant
      
      // // 2023-05-24 因为解析出的数据数字类型会精度丢失，尝试改为定界分隔符输出,但是输出的值全都是字符串，没有区分其他类型，罢了罢了
      // const contant = []
      // const csvss = XLSX.utils.sheet_to_csv(sheet, { FS: ",", RS: "|" })
      // if (csvss)      {
      //   const firsts = csvss.split('|')
      //   const codes = firsts[0]
      //   let keys = []
      //   if (codes)        {
      //     keys = codes.split(',')
      //   }
      //   firsts.forEach((el, idx) => {
      //     if (idx != 0 && el)          {
      //       const values = el.split(',')
      //       let obj = {}
      //       values.forEach((va, i) => {
      //         obj[keys[i]] = va
      //       })
      //       contant.push(obj)
      //     }
      //   });
      // }
      const res = contant.map((item) => {
        const keys = Object.keys(item);
        const values = Object.values(item);
        // console.log(keys, 'keys');

        const newItem = {};
        keys.forEach((k, i) => {
          const _k = setKey(k);

          if (values[i] instanceof Date) {
            let s = values[i].getTime() + 43000;
            let stime = values[i].getTime();
            
            if (new Date(stime).getFullYear() == 1899) {
              // console.log(s, stime,new Date(stime).getFullYear(),values[i]);
              values[i] =
                pZone(new Date(stime).getHours()) +
                ":" +
                pZone(new Date(stime).getMinutes()) +
                ":" +
                pZone(new Date(stime).getSeconds());
            } else {
              values[i] = new Date(s);
            }
          }
          const _v = setVal(values[i]);
          newItem[_k] = _v;
        });
        return newItem;
      });
      function pZone(s) {
        return s < 10 ? "0" + s : s;
      }
      function setKey(key) {
        const _k = key
          .replace(/(__EMPTY_)([\d]+)/, "F$2")
          .replace("__EMPTY", "F1");
        if (/^F[\d]+$/.test(_k)) {
          const idx = _k.slice(1);
          return `F${Number(idx) + 1}`;
        } else {
          return key; //.replace(/\./i, '#') // 跟 getHeaderRow 处理要对应 (处理不了带·的key值)
          // 2023/1/31 因为将头部key中的小数点替换为#，故先注释.replace(/\./i, '#')
        }
      }
      function setVal(str) {
        if (typeof str === "object") {
          // 20230204 如果待时分秒，则不能只截取日期
          return str.getHours() == 0 &&
            str.getMinutes() == 0 &&
            str.getSeconds() == 0
            ? parseTime(str, "{y}/{m}/{d}")
            : parseTime(str);
        } else if (typeof str !== "string") {
          return str;
        } else {
          return str;
        }
        // const _s = str.replace(/(__EMPTY_)([\d]+)/, 'F$2').replace('__EMPTY', 'F1');

        // if (/^F[\d]+$/.test(_s)) {
        //   console.log(_s,'dddddddd')
        //   const idx = _s.slice(1)
        //   return `F${Number(idx) + 1}`
        // } else {
        //   return str
        // }
      }
      return res;
    },
    // 获取 表头
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        /* find the cell in the first row */
        let hdr = "F" + (C + 1); // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell); //.replace(/\./gi, '#') //  跟 getHeaderRow 处理要对应 (处理不了带·的key值)
        // 2023/1/31 因为将头部key中的小数点替换为#，故先注释.replace(/\./i, '#')
        headers.push(hdr);
      }
      return headers;
    },
    // 生成数据
    generateData({ header, results }) {
      this.excelData.header = header;
      this.excelData.results = results;
      this.excelData.excelName = this.file.name;
      console.log(this.excelData,'this.excelData')
      this.onSuccess && this.onSuccess(this.excelData);
    },
    // 弹窗关闭前
    beforeClose(action, done) {
      this.sheetSelectShow = false; // 需要手动 关闭弹窗
      if (action === "confirm") {
        const sheet = this.$refs.sheetSelect.sheet;
        this.sheetName = sheet;
        this.upload(this.file);
        done();
      } else {
        this.$refs["excel-upload-input"].value = null; // fix can't select the same excel
        done();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}
.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
